<template>
  <div id="app" style="display: flex; flex-direction: column; min-height: 100vh;">
    <div class="nav-wrapper" style="background-color: #fff; width: 100%;">
      <div class="nav">
      <div class="title">
        <div class="title1">
          <!-- <el-image class="web_logo" src="../images/1.png"></el-image> -->
          <span>PMGD</span>
        </div>
        <!-- 注销使用 -->
        <!-- <div class="title2">A Mitochondrial Genome Database for Plants</div> -->
      </div>
      <el-menu
        class="el-menu-demo"
        :mode="screenWidth > 1274 ? 'horizontal' : ''"
        style="margin: auto 0 auto auto"
        :default-active="$route.path"
        router
      >
        <el-menu-item index="/GeneHome"
          ><svg
            t="1729501614483"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="3977"
            width="20"
            height="20"
          >
            <rect width="100%" height="100%" fill="#e6e6fa" />
            <path
              d="M946.5 505L560.1 118.8l-25.9-25.9c-12.3-12.2-32.1-12.2-44.4 0L77.5 505c-12.3 12.3-18.9 28.6-18.8 46 0.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8 12.1-12.1 18.7-28.2 18.7-45.3 0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204z m217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
              p-id="3978"
              fill="#707070"
            ></path></svg
          ><span class="label">Home</span></el-menu-item
        >
        <el-menu-item index="/Genomes"
          ><svg
            t="1729501761502"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5051"
            width="20"
            height="20"
          >
            <rect width="100%" height="100%" fill="#e6e6fa" />
            <path
              d="M665.472 0l45.12 37.76-55.04 69.504c-20.928 26.304-28.672 51.52-25.28 81.728 3.84 33.792 21.376 75.52 55.36 131.456 4.032 6.656 8.192 13.568 12.416 20.864 6.464 5.12 12.8 10.24 18.688 15.104 49.984 41.216 88.32 64.128 120.512 72 28.736 7.04 54.016 2.048 81.92-16.128l73.664-48.064 31.168 50.496-73.6 48.064c-41.152 26.88-82.56 34.624-126.656 23.872-22.848-5.632-47.232-16.384-74.24-33.024 4.8 15.104 8.576 30.528 11.328 46.144 12.672 73.92-3.52 142.4-48.192 203.52-6.528 8.896-31.872 32-42.752 38.08-39.68 22.4-80.64 33.536-122.176 33.536a249.984 249.984 0 0 1-80-13.568 317.312 317.312 0 0 1-32-12.8c13.12 28.544 20.928 53.952 24.064 77.44 6.208 46.144-5.312 87.744-35.2 127.232L371.008 1024l-45.888-36.736 53.568-70.72c20.288-26.816 27.52-52.224 23.488-82.304-4.48-33.664-23.04-75.008-58.24-130.176a1085.312 1085.312 0 0 1-15.488-25.088c-7.936-6.4-15.36-12.8-22.528-18.88-49.088-42.432-86.848-66.176-118.848-74.752-28.608-7.68-54.016-3.328-82.304 14.272l-74.688 46.4-30.08-51.2 74.688-46.4c41.6-25.856 83.2-32.64 127.04-20.928 22.336 5.952 45.952 16.96 72 33.664a338.56 338.56 0 0 1-8.64-34.176c-14.336-73.344 0.192-142.016 43.072-204.032 7.168-10.304 32.512-33.472 41.856-39.04 64.32-38.4 132.352-46.912 202.304-25.344 14.848 4.672 29.312 10.304 43.328 17.024-12.928-29.504-20.48-55.68-23.168-79.68-5.248-46.272 7.168-87.616 37.888-126.4L665.472 0zM146.24 675.328l158.528 183.36-43.52 39.68-158.464-183.36 43.52-39.68z m95.872-39.488l112.064 129.6-43.52 39.68-112-129.6 43.52-39.68z m629.76-40.704c49.536 0 89.728 41.344 89.728 92.288 0 50.944-40.192 92.224-89.792 92.288-49.6 0-89.792-41.28-89.792-92.288 0-50.944 40.192-92.288 89.792-92.288z m0 59.84c-12.8 0-24.384 7.872-29.312 20.032a33.152 33.152 0 0 0 6.912 35.392 30.976 30.976 0 0 0 34.432 7.04 32.512 32.512 0 0 0 19.52-30.016 32.128 32.128 0 0 0-31.616-32.448z m-218.176-273.152c-82.944-63.616-173.312-106.368-274.048-46.464a223.872 223.872 0 0 0-24.32 22.592c-66.112 95.872-35.008 190.848 17.28 280.576 80.448 63.936 168.64 106.88 269.056 50.56 4.8-3.136 20.672-17.408 24.704-22.08 69.76-95.808 39.04-193.024-12.672-285.184zM403.584 491.2l111.36 130.048-43.648 39.488-111.36-130.048 43.648-39.488z m50.432-96.96l158.528 183.36-43.52 39.68-158.528-183.296 43.52-39.68z m95.872-39.488l112.064 129.664-43.52 39.68-112-129.6 43.52-39.68z m-361.472-11.584a83.2 83.2 0 0 1 49.92 76.8c0 45.888-36.224 83.072-80.896 83.136-32.64 0-62.208-20.288-74.688-51.328a84.8 84.8 0 0 1 17.536-90.624 79.296 79.296 0 0 1 88.128-17.984z m-30.976 53.44a23.04 23.04 0 0 0-22.656 23.36 23.04 23.04 0 0 0 22.656 23.296 23.04 23.04 0 0 0 22.72-23.296 23.04 23.04 0 0 0-22.72-23.36z m554.88-190.144l112.064 129.6-43.52 39.68-112-129.6 43.52-39.68z m49.472-93.248l158.464 183.36-43.52 39.68-158.464-183.296 43.52-39.68zM457.088 14.976c37.12 15.808 61.248 52.992 61.248 94.272-0.064 56.32-44.48 101.952-99.264 102.016a99.264 99.264 0 0 1-91.712-62.976A104.064 104.064 0 0 1 348.864 37.056a97.28 97.28 0 0 1 108.16-22.08z m-38.016 52.032c-16.64 0-31.616 10.24-37.952 26.048-6.4 15.808-2.816 33.92 8.96 46.08a40.32 40.32 0 0 0 44.736 9.088 42.24 42.24 0 0 0 25.344-39.04 41.728 41.728 0 0 0-41.088-42.176z"
              p-id="5052"
              fill="#707070"
            ></path></svg
          ><span class="label">Mitogenomes</span></el-menu-item
        >
        <el-menu-item index="/Genes"
          ><svg
            t="1729501806999"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6301"
            width="20"
            height="20"
          >
            <rect width="100%" height="100%" fill="#e6e6fa" />
            <path
              d="M691.582463 484.25271c151.685187-88.991309 254.075188-253.275266 254.075188-441.55688C945.657651 19.098135 926.559516 0 902.96182 0s-42.69583 19.098135-42.69583 42.69583c0 36.196465-4.999512 71.093057-13.498682 104.689777H177.132702c-8.49917-33.596719-13.498682-68.493311-13.498682-104.689777 0-23.597696-19.098135-42.69583-42.69583-42.69583S78.242359 19.098135 78.242359 42.69583c0 56.394493 9.499072 110.5892 26.497413 161.38424 0.499951 1.399863 0.799922 2.699736 1.499853 3.99961 20.098037 58.594278 50.095108 112.589005 88.691339 159.484425 0.09999 0.09999 0.09999 0.09999 0.09999 0.199981 38.39625 46.59545 85.09169 85.891612 137.386583 116.588614C185.631872 527.948443 78.242359 664.035153 78.242359 824.819451v156.484719c0 23.597696 19.098135 42.69583 42.695831 42.69583s42.69583-19.098135 42.69583-42.69583V849.417049h696.83195v131.78713c0 23.597696 19.098135 42.69583 42.695831 42.695831s42.69583-19.098135 42.69583-42.695831V824.819451c-0.09999-160.784298-107.489503-296.871009-254.275168-340.566741z m-497.951372 217.178791c0.799922 0 1.599844 0.499951 2.399765 0.499951h625.738893c2.799727 0 5.299482-1.099893 7.999219-1.599844 10.398984 19.898057 18.298213 41.295967 23.497705 63.79377H170.733327c5.099502-22.097842 12.79875-43.095791 22.897764-62.693877zM512 461.754907c-67.593399-12.59877-129.387365-41.195977-181.782248-81.692023h363.564496c-52.394883 40.496045-114.188849 69.093253-181.782248 81.692023z m303.170394-229.077629c-10.898936 21.897862-23.697686 42.59584-38.09628 62.193926H246.825896c-14.398594-19.498096-27.097354-40.296065-38.09628-62.193926h606.440778z m-224.97803 321.968557c65.293624 0 125.287765 23.297725 171.983205 61.993946H261.724441c46.79543-38.696221 106.689581-61.993946 171.983205-61.993946 26.697393 0 52.694854-2.699736 78.192364-6.599355 25.69749 3.899619 51.694952 6.599356 78.292354 6.599355z"
              p-id="6302"
              fill="#707070"
            ></path></svg
          ><span class="label">Genes</span></el-menu-item
        >
        <el-submenu index="/Tools">
          <template slot="title"
            ><svg
              t="1729501868963"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9216"
              width="20"
              height="20"
            >
              <rect width="100%" height="100%" fill="#e6e6fa" />
              <path
                d="M818.773333 386.261333l-90.538666 90.517334a64 64 0 0 1-90.517334 0l-90.496-90.496a64 64 0 0 1 0-90.517334l90.517334-90.538666a213.44 213.44 0 0 0-222.741334 303.189333l13.013334 27.242667L200.256 763.392l60.352 60.352L488.32 595.989333l27.221333 13.013334A213.44 213.44 0 0 0 818.773333 386.261333z m-12.458666-108.245333c21.824-21.824 59.093333-15.637333 72.32 12.842667 51.114667 110.378667 31.232 245.653333-59.882667 336.768-84.288 84.288-206.336 107.626667-311.530667 70.186666l-201.365333 201.344a64 64 0 0 1-90.496 0l-90.517333-90.496a64 64 0 0 1 0-90.517333l201.344-201.344c-37.44-105.216-14.101333-227.264 70.186666-311.552C487.466667 114.133333 622.762667 94.250667 733.141333 145.386667c28.48 13.184 34.666667 50.474667 12.842667 72.32l-123.349333 123.306666 60.352 60.352 123.306666-123.328z"
                p-id="9217"
                fill="#707070"
              ></path></svg
            ><span class="label">Tools</span></template
          >
          <el-menu-item index="/SequenceServer"
            ><span>SequenceServer</span></el-menu-item
          >
          <el-menu-item index="/JBrowse">JBrowse</el-menu-item>
          <el-menu-item index="/HeatMapTool">HeatMap</el-menu-item>
          <el-menu-item index="/PhylogeneticTree">Phylogenetic analysis</el-menu-item>
          <!-- 注销掉这几个软件，改为放置在首页右下方的链接中 -->
          <el-menu-item class="soft_PMAT" @click="gotoPages('https://github.com/bichangwei/PMAT')">
              PMAT
          </el-menu-item>
          <el-menu-item class="soft_PMAT2" @click="gotoPages('https://github.com/aiPGAB/PMAT2')">
            PMAT2
          </el-menu-item>
          <!-- 还差一个软件 -->
          <!-- <el-menu-item class="soft_PMAT2" @click="gotoPages('...')">
            ...
          </el-menu-item> -->
        </el-submenu>

        <el-menu-item index="/PublicationHome"
          ><svg
            t="1729502195203"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="10316"
            width="20"
            height="20"
          >
            <rect width="100%" height="100%" fill="#e6e6fa" />
            <path
              d="M921.313481 307.394424H887.238133v409.31348h-34.075347V239.141401s-238.732088 0-341.060458 76.746278C407.932048 239.346058 170.939542 239.141401 170.939542 239.141401v477.566503h-34.075347v-409.31348h-34.075347v409.31348s0 34.075347 34.075347 34.075348h272.909763c11.460777 2.353553 32.540422 5.01409 51.880484 18.623763 23.740182 16.679524 46.150095 15.553912 50.550215 15.451584 4.40012 0.102328 26.912361 1.22794 50.550215-15.451584 19.237734-13.507345 40.010393-16.270211 51.573498-18.623763H887.238133c34.075347 0 34.075347-34.075347 34.075348-34.075348v-409.31348z m-375.135805 68.150694c102.32837-68.253023 238.732088-68.253023 238.732087-68.253022V648.454882s-168.739482 18.521435-235.969221 53.620066c0-25.889078-2.762866-319.980813-2.762866-326.52983z m-68.253023 0c0 6.446687 0.61397 300.640751 0.61397 326.52983-67.229739-35.098631-239.346058-53.620066-239.346058-53.620066v-341.060458s136.403717 0 238.732088 68.150694z"
              fill="#707070"
              p-id="10317"
            ></path></svg
          ><span class="label">Publications</span></el-menu-item
        >
        <el-menu-item index="/Statistics"
          ><svg
            t="1729502236329"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="11843"
            width="20"
            height="20"
          >
            <rect width="100%" height="100%" fill="#e6e6fa" />
            <path
              d="M176 384a95.536 95.536 0 0 0 54.24-16.8l170.032 102A95.92 95.92 0 0 0 496.016 560c58.144 0 104.448-51.872 94.608-111.664l216.368-195.744a95.84 95.84 0 0 0 25.04 3.408 96 96 0 1 0-96-96c0 14.56 3.328 28.304 9.12 40.656L545.12 381.616a95.52 95.52 0 0 0-114.688 12.4l-159.056-95.424A96 96 0 1 0 176 384z m208 576h240V656H384v304z m80-224h80v144h-80v-144zM80 960h240V512H80v448z m80-368h80v288h-80V592z m528 368h240V432H688v528z m80-448h80v368h-80V512z"
              fill="#707070"
              p-id="11844"
            ></path></svg
          ><span class="label">Statistics</span></el-menu-item
        >
        <el-menu-item index="/AboutUs"
          ><svg
            t="1729502285754"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="15452"
            width="20"
            height="20"
          >
            <rect width="100%" height="100%" fill="#e6e6fa" />
            <path
              d="M737 619.3c-29.2-29.2-63.2-52.2-101.1-68.2-9.3-3.9-18.7-7.4-28.3-10.4 58.2-33.3 97.4-96 97.4-167.8 0-106.7-86.5-193.2-193.2-193.2s-193.2 86.5-193.2 193.2c0 71.9 39.3 134.6 97.5 167.9-9.5 3-18.8 6.4-28 10.3-37.9 16-71.9 39-101.1 68.2-29.2 29.2-52.2 63.2-68.2 101.1-16.6 39.3-25 80.9-25 123.9 0 22.1 17.9 40 40 40s40-17.9 40-40c0-131.4 106.9-238.2 238.2-238.2 131.4 0 238.2 106.9 238.2 238.2 0 22.1 17.9 40 40 40s40-17.9 40-40c0-42.9-8.4-84.6-25-123.9-16-37.9-39-71.9-68.2-101.1zM431.8 292.9c21.4-21.4 49.8-33.1 80-33.1s58.6 11.8 80 33.1c21.4 21.4 33.1 49.8 33.1 80 0 30.2-11.8 58.6-33.1 80-21.4 21.4-49.8 33.1-80 33.1s-58.6-11.8-80-33.1c-21.4-21.4-33.1-49.8-33.1-80-0.1-30.2 11.7-58.7 33.1-80z"
              fill="#707070"
              p-id="15453"
            ></path>
            <path
              d="M320.5 580.2c8.3-3.6 14.9-10.9 17.3-20.3 4-16.1-5.8-32.3-21.9-36.3-54.9-13.6-93.3-62.7-93.3-119.4 0-51 32.1-97.3 79.8-115.2 15.5-5.8 23.4-23.1 17.5-38.6-5.8-15.5-23.1-23.4-38.6-17.5-34.5 12.9-64 35.8-85.3 66-21.8 30.9-33.4 67.4-33.4 105.4 0 41.1 14 81.5 39.5 113.6 9.5 11.9 20.4 22.6 32.4 31.8-40 17.4-75.7 44-103.9 77.9C88.9 677.5 66 741 66 806.2c0 16.6 13.4 30 30 30s30-13.4 30-30c0-104.7 74.4-195.4 177-215.5 7.2-1.5 13.2-5.3 17.5-10.5zM895.3 627.5c-28.2-33.9-64-60.6-103.9-77.9 12-9.2 22.9-19.8 32.4-31.8 25.5-32.2 39.5-72.5 39.5-113.6 0-38-11.5-74.4-33.4-105.4-21.3-30.2-50.8-53-85.3-66-15.5-5.8-32.8 2-38.6 17.5s2 32.8 17.5 38.6c47.7 17.9 79.8 64.2 79.8 115.2 0 56.7-38.4 105.8-93.3 119.4-16.1 4-25.9 20.3-21.9 36.3 2.3 9.5 9 16.8 17.3 20.3 4.3 5.2 10.3 9 17.4 10.4 102.6 20.2 177 110.8 177 215.5 0 16.6 13.4 30 30 30s30-13.4 30-30c0-65-22.9-128.5-64.5-178.5z"
              fill="#707070"
              p-id="15454"
            ></path></svg
          ><span class="label">About Us</span></el-menu-item
        >
      </el-menu>
    </div>
    </div>
    
    <div class="main-content" style="flex: 1; background-color: #f5f7fa; padding-bottom: 20px; padding-top: 20px;">
      <!-- 缓存组件 -->
      <keep-alive include="SequenceServer,TreeResult">
        <router-view></router-view>
      </keep-alive>
    </div>

    <!-- 全局底出版权信息 -->
    <Licenses />
  </div>
</template>

<script>
// import img1 from '../images/index1.jpg'
import Licenses from './Licenses.vue';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "GeneBody",
  components: { Licenses },
  data() {
    return {
      activeIndex: "/",
      screenWidth: 1537,
      //滚轮滑动改变背景
    };
  },
  methods: {
    gotoPages(url){
      console.log(url);
      window.open(url, '_blank');
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
};
</script>
<style scoped>
.nav .title {
  /* 去掉固定的 27% 宽度，让它自适应，方便压缩与右侧的距离 */
  margin-right: 20px;
  height: 60px; /* 稍微加高以适应更大的按钮 */
  display: flex;
  align-items: center;
}
.web_logo {
  display: inline-block;
  width: 44px;
  margin-right: 4px;
  vertical-align: middle;
}
.nav .title .title1 {
  font-size: 40px;
  margin: 4px 0;
  font-weight: 800; /* 加大字重 */
  color: #a29bfe;
}
.nav .title .title2 {
  padding-top: 5px;
  font-size: 15px;
  font-weight: 400;
  color: green;
  opacity: 0.5;
  font-family: "Times New Roman", Times, serif;
}
.nav {
  width: 1300px;
  margin: auto;
  position: relative;
  display: flex;
  background-color: #fff;
}
.label {
  font-size: 14px; /* 字体改小 */
  font-weight: 600; /* 加粗 */
}
svg {
  margin: 0 4px 0 0;
  width: 16px; /* 图标改小 */
  height: 16px;
}

/* 隐藏导航栏底部的默认边框 */
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}

/* 将每一个单独的导航项做成按钮样式，整体缩小并增加底部外边距，同时加大左右间距 */
::v-deep .el-menu--horizontal > .el-menu-item,
::v-deep .el-menu--horizontal > .el-submenu > .el-submenu__title {
  height: 36px !important; /* 按钮变矮 */
  line-height: 36px !important;
  margin: 16px 14px 16px 14px !important; /* 加大左右外边距到14px，拉开菜单之间的距离 */
  padding: 0 16px !important; /* 略微加大内边距 */
  border-radius: 18px; /* 相应调整圆角 */
  border: 1px solid #ebeef5;
  background-color: #f4f4f5;
  color: #606266;
  font-size: 14px; /* 子菜单文字也改小 */
  font-weight: 600;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

/* 按钮的悬浮与激活效果 (浅紫色) */
::v-deep .el-menu--horizontal > .el-menu-item:hover,
::v-deep .el-menu--horizontal > .el-submenu:hover .el-submenu__title,
::v-deep .el-menu--horizontal > .el-menu-item.is-active,
::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  background-color: #a29bfe !important;
  color: #ffffff !important;
  border-color: transparent !important; /* 去掉边框变色，并隐藏Element原生激活底边框 */
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(162, 155, 254, 0.3);
}

/* 悬浮/激活时，把 SVG 图标里的颜色强制变白，并去掉淡紫色底块 */
::v-deep .el-menu--horizontal > .el-menu-item:hover svg path,
::v-deep .el-menu--horizontal > .el-submenu:hover .el-submenu__title svg path,
::v-deep .el-menu--horizontal > .el-menu-item.is-active svg path,
::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title svg path {
  fill: #ffffff !important;
}

::v-deep .el-menu--horizontal > .el-menu-item:hover svg rect,
::v-deep .el-menu--horizontal > .el-submenu:hover .el-submenu__title svg rect,
::v-deep .el-menu--horizontal > .el-menu-item.is-active svg rect,
::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title svg rect {
  fill: transparent !important;
}

/* 处理多级菜单下拉箭头的位置和颜色 */
::v-deep .el-submenu__title i {
  color: inherit !important;
  margin-left: 4px;
}
</style>
